module.exports = __webpack_public_path__ + "static/media/2019akhil.b4972653.jpg";